import styled from 'styled-components/native'
import { Fonts, Metrics } from 'APP/Themes'

export const MarkdownStyles = {
  p: {
    marginBottom: 0,
    ...Fonts.style.body,
    lineHeight: Metrics.baseMargin * 1.25,
  },
}

export const ContentContainer = styled.View`
  padding-horizontal: ${({ theme }) => theme.metrics.baseMargin * 1.375}px;
  padding-bottom: ${({ theme }) => theme.metrics.bottomSpace || theme.metrics.baseMargin}px;
`

export const TargetLabelContainer = styled.View`
  align-items: center;
  padding-top: ${({ theme }) => theme.metrics.baseMargin * 2}px;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const SliderContainer = styled.View`
  display: flex;
  align-items: center;
  padding-bottom: ${({ theme }) => theme.metrics.baseMargin}px;
`

export const SliderValuesContainer = styled.View`
  flex-direction: row;
  align-self: stretch;
  justify-content: space-between;
`

export const BannerContainer = styled.View`
  flex-direction: row;
  padding: ${({ theme }) => theme.metrics.baseMargin * 1.3}px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.colors.bannerBg};
`

export const MarkdownContainer = styled.View`
  padding-right: ${({ theme }) => theme.metrics.baseMargin * 1.3}px;
  padding-left: ${({ theme }) => theme.metrics.baseMargin * 0.6}px;
  max-width: 100%;
`
